import ExportConfig from './export-config'
import { exportWithSheetJS } from './sheetjs-engine'
import { exportWithTableExport } from './tableexport-engine'

const ExcelExport = {
  async exportSheet(sheetData, fileName) {
    if (ExportConfig.useSheetJS()) {
      return exportWithSheetJS(sheetData, fileName)
    }
    return exportWithTableExport(sheetData, fileName)
  },
}

export default ExcelExport
